import Swal from "sweetalert2";
import { ActionContext } from "vuex";
import { IAppState } from "./state";
import { IRootState } from "../../types";

export interface IAppActions {
  openSpinner(context: ActionContext<IAppState, IRootState>): void;

  closeSpinner(context: ActionContext<IAppState, IRootState>): void;

  popupDialog(
    context: ActionContext<IAppState, IRootState>,
    param: string
  ): void;
}

export const AppActions: IAppActions = {
  openSpinner: ({ commit }: ActionContext<IAppState, IRootState>) =>
    commit("OPEN_SPINNER"),
  closeSpinner: ({ commit }: ActionContext<IAppState, IRootState>) =>
    commit("CLOSE_SPINNER"),
  popupDialog(_: ActionContext<IAppState, IRootState>, param: any) {
    return new Promise<void>((resolve, reject) => {
      Swal.fire({
        title: "Skola",
        icon: param.type || "",
        text: param.text,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        html: param.html,
        backdrop: "false rgba(0,0,0,0.5)",
        allowOutsideClick: false,
        imageUrl: "@/assets/images/logoHome.png",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        showCancelButton: param.showCancelButton,
        confirmButtonText: "OK",
        cancelButtonText: "CANCELAR",
      })
        .then((result: any) => {
          if (result.value) {
            resolve();
            return;
          } else {
            reject();
          }
        })
        .catch(() => reject());
    });
  },
};
